import { RobotoLinkHoverUnderline } from "@/shared/components/RobotoLinkHoverUnderline";
import { Goto } from "@/shared/navigation/Goto";

interface DeviceIdLabelProps {
  deviceId: string;
}

/**
 * A device ID linked to its device page, with no icon: the same look as a
 * principal such as a dataset's Created by.
 *
 * Device IDs are free-form, so this builds the link from the ID rather than
 * parsing a `device:` principal, which rejects a colon and cuts at an `@`.
 */
export function DeviceIdLabel({ deviceId }: DeviceIdLabelProps) {
  return (
    <RobotoLinkHoverUnderline to={Goto.createDeviceRoute(deviceId)}>
      {deviceId}
    </RobotoLinkHoverUnderline>
  );
}
